export default {
  report_hashtag: [],
  report_corrective: [],
  start_year: '',
  end_year: '',
  organization: {},
  time: [],
  report: [],
  type: '' // 0: theo quí 1 theo năm
}



// WEBPACK FOOTER //
// ./src/store/module/report/state.js